import {
  GET_ADMINS_FAIL,
  GET_ADMINS_SUCCESS,
  GET_ADMIN_DETAIL_FAIL,
  GET_ADMIN_DETAIL_SUCCESS,
  ADD_ADMIN_SUCCESS,
  ADD_ADMIN_FAIL,
  UPDATE_ADMIN_SUCCESS,
  UPDATE_ADMIN_FAIL,
  CLEAR_MESSAGE,
  DELETE_ADMIN_SUCCESS,
  DELETE_ADMIN_FAIL,
  CHANGE_PASSWORD_ADMIN_SUCCESS,
  CHANGE_PASSWORD_ADMIN_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  adminList: [],
  adminDetail: {},
  error: {},
  message: "",
  pagination: {},
  search: "",
}

const admins = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ADMINS_SUCCESS:
      return {
        ...state,
        adminList: action.payload?.data,
        pagination: action.payload?.pagination || {},
      }

    case GET_ADMINS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_ADMIN_SUCCESS:
      return {
        ...state,
        adminList: [...state.adminList, action?.payload?.data || {}],
        message: action?.payload?.message || "",
      }

    case ADD_ADMIN_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ADMIN_DETAIL_SUCCESS:
      return {
        ...state,
        adminDetail: action.payload,
      }

    case UPDATE_ADMIN_SUCCESS:
      return {
        ...state,
        message: "Successfully admin updated!",
        adminList: (state?.adminList || []).map(admin => {
          return admin._id.toString() === action.payload?.data._id.toString()
            ? { admin, ...action.payload?.data }
            : admin
        }),
      }

    case UPDATE_ADMIN_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ADMIN_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_ADMIN_SUCCESS:
      return {
        ...state,
        message: "Successfully admin deleted!",
        adminList: (state?.adminList || []).filter(
          admin => admin._id.toString() !== action.payload._id.toString()
        ),
      }

    case DELETE_ADMIN_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case CLEAR_MESSAGE:
      return {
        ...state,
        error: {},
        message: "",
      }
    case CHANGE_PASSWORD_ADMIN_SUCCESS:
      console.log("first", action?.payload)
      return {
        ...state,
        message: action?.payload,
      }
    case CHANGE_PASSWORD_ADMIN_FAIL:
      return {
        ...state,
        error: action?.payload,
      }

    default:
      return state
  }
}

export default admins
